module.exports = __webpack_public_path__ + "img/logo-ac.d308d9bb.svg";